const enterSpaceHelper = (fn) => (e) => {
  switch (e.code) {
    case `Space`:
    case `Enter`:
      e.preventDefault();
      return fn();
    default:
      return true;
  }
};
export { enterSpaceHelper };
